import MonoTextuary from "./Components/MonoTextuary";

export default MonoTextuary;
